// The one call the FE makes after every successful Stytch authenticate
// (CONTRACT.md → POST /auth/provision). Idempotent, so the callback page can
// retry it freely. Pure async function: no React, no caching.
import { client } from "@/shared/api/client";
import { unwrap, type Envelope } from "@/shared/api/envelope";

import type { Settings } from "@/shared/types";

export async function provision(): Promise<Settings> {
  return unwrap(await client.post<Envelope<Settings>>("/auth/provision", {}));
}
